import React, { useState, useEffect } from "react";
import { Container, Button, Card } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
  getpackageCategory,
  deletepackageCategory,
} from "../../store/slices/packagecategory";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "./deletepopup";

export default function Category() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { packageCategoryList = [], loading } = useSelector(
    (state) => state.packageCategory,
  );

  const pagelimit = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const fetchAmenities = async () => {
    try {
      await dispatch(getpackageCategory()).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAmenities();
  }, []);

  const totalPages = Math.ceil(packageCategoryList.length / pagelimit);
  const startIndex = (currentPage - 1) * pagelimit;
  const paginatedData = packageCategoryList.slice(
    startIndex,
    startIndex + pagelimit,
  );

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deletepackageCategory(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/category")}
          >
            Category
          </span>
        </div>

        {/* Right: Button */}
        <Button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addcategory")}
        >
          Add Category
        </Button>
      </div>

      <Container>
        <Card style={{ border: "none" }} className="mb-5">
          <Card.Body>
            <div className="common-table-wrapper">
              <table className="common-table">
                <thead>
                  <tr>
                    <th className="text-center">#</th>

                    <th className="text-center">Category Name</th>

                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>

                  {loading
                    ? [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                    : paginatedData.map((place, index) => (
                      <tr key={place.id}>
                        <td className="text-center">{index + 1}</td>

                        <td className="text-center w-50">{place.name}</td>

                        <td className="text-center">
                          <div className="action-btn-group">
                            <button
                              className="action-btn edit-btn"
                              onClick={() =>
                                navigate(`/admin/editcategory/${place._id}`)
                              }
                            >
                              <FaEdit size={14} />
                            </button>

                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(place._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>

              </table>

              {totalPages > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "6px",
                    padding: "14px",
                  }}
                >
                  <button
                    className="btn btn-light btn-sm"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                  >
                    Prev
                  </button>

                  {Array.from({ length: totalPages }).map((_, i) => (
                    <button
                      key={i}
                      className={`btn btn-sm ${currentPage === i + 1 ? "btn-primary" : "btn-light"
                        }`}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    className="btn btn-light btn-sm"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Container>

      {/* delete model popup */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
